import * as React from "react";
import { forwardRef, memo } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 10.2668L4 6.26683L4.93333 5.3335L8 8.40016L11.0667 5.3335L12 6.26683L8 10.2668Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgChevronDown);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
